import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import SubmitButtonModel, { NULL as SubmitButtonModelNULL } from './model'
import findAncestor from '@client/utils/findAncestor'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import { defaultSettings } from './constants'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { FORM_BUTTON_ALIGN_OPTIONS } from '@client/components/blocks/Form/constants'
import { DEFAULT_PADDING } from '@client/components/Block/constants'

import inlineStyles from './inlineStyles'

const PADDING = 2 * DEFAULT_PADDING

export class SubmitButton extends Component {
  static propTypes = {
    model: PropTypes.instanceOf(SubmitButtonModel),
    editor: PropTypes.instanceOf(EditorModel),
    app: PropTypes.instanceOf(AppModel),
    serverRender: PropTypes.bool,
  }

  static defaultProps = {
    model: SubmitButtonModelNULL,
    editor: EditorModelNULL,
    app: AppModelNULL,
    serverRender: false,
  }

  componentDidMount() {
    this.column = findAncestor(this.dom, 'column')
    this.setContainerDimentions()
    if (this.column) {
      this.resizeObserver = new ResizeObserver(() => this.setContainerDimentions())
      this.resizeObserver.observe(this.column)
    }
  }

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  calculateStyles = (settings, globalSettings) => {
    const align = settings.align || globalSettings.button_simple_align
    const height = settings.height || globalSettings.button_height
    const borderStyle =
      settings.borderStyle || globalSettings.button_borderStyle
    const borderColor =
      settings.borderColor || globalSettings.button_borderColor
    const borderWidth =
      settings.borderWidth || globalSettings.button_borderWidth
    return {
      width: align === FORM_BUTTON_ALIGN_OPTIONS[3].value ? '100%' : 'auto',
      minWidth:
        align === FORM_BUTTON_ALIGN_OPTIONS[3].value ? '100%' : undefined,
      lineHeight: typeof height === 'undefined' ? undefined : height + 'px',
      maxHeight: typeof height === 'undefined' ? undefined : 2 * +height + 'px',
      fontSize: (settings.fontSize || globalSettings.button_fontSize) + 'px',
      border: borderWidth
        ? `${borderWidth}px ${borderStyle} ${borderColor}`
        : 'none',
      borderRadius:
        (settings.borderRadius || globalSettings.button_borderRadius) + 'px',
      background:
        settings.backgroundColor || globalSettings.button_backgroundColor,
      color: settings.textColor || globalSettings.button_textColor,
      paddingLeft:
        align === FORM_BUTTON_ALIGN_OPTIONS[3].value
          ? 0
          : inlineStyles.button.paddingLeft,
      paddingRight:
        align === FORM_BUTTON_ALIGN_OPTIONS[3].value
          ? 0
          : inlineStyles.button.paddingRight,
    }
  }

  setContainerDimentions() {
    if (!this.column) {
      return
    }
    this.props.model.setContainerDimensions({
      width: this.column.clientWidth - PADDING,
    })
  }

  render() {
    const globalSettings = this.props.editor.settings.values
    const settings = this.props.model.settings.values
    const styles = {
      ...inlineStyles.button,
      ...this.calculateStyles(settings, globalSettings),
      fontFamily: globalSettings.normalText_fontFamily,
    }
    const formatMessage = this.props.app.formatMessage

    const text = settings.text || ''
    const align = settings.align || globalSettings.button_simple_align
    let wrapperClassName = this.props.serverRender ? '' : 'button'
    if (align === 'full-width') {
      wrapperClassName += wrapperClassName ? ' full-width' : 'full-width'
    }

    return (
      <div
        style={{ padding: '5px 0' }}
        className={wrapperClassName}
        align={align.replace('text-', '').replace('full-width', '')}
        ref={(el) => (this.dom = el)}
      >
        <div
          className="g-recaptcha"
          data-sitekey="##google_captcha_site_key##"
          data-callback="onSubmit"
          data-expired-callback="onExpiredCallback"
          data-error-callback="onErrorCallback"
          data-action="submit"
          data-size="invisible"
        />
        <button
          type="submit"
          className="btn"
          style={styles}
          onClick={(ev) => {
            ev.preventDefault()
          }}
          tabIndex="0"
        >
          {text ? (
            <span
              style={{
                color: settings.textColor || globalSettings.button_textColor,
                fontWeight:
                  settings.fontWeight || globalSettings.button_fontWeight,
              }}
            >
              {defaultSettings.text === text
                ? formatMessage(defaultSettings.text)
                : text}
            </span>
          ) : (
            <span
              style={{
                color: settings.textColor || globalSettings.button_textColor,
                fontWeight:
                  settings.fontWeight || globalSettings.button_fontWeight,
              }}
              dangerouslySetInnerHTML={{
                __html: '&nbsp;',
              }}
            />
          )}
        </button>
        <div className="gan-field-recapcha">
          <div
            className="gan-validation-form-error"
            style={{
              color: 'red',
              fontSize: `${globalSettings.normalText_fontSize * 0.7}px`,
              justifyContent: 'center',
            }}
          />
        </div>
        <div
          className="gan-validation-form-error"
          style={{
            color: 'red',
            fontSize: `${globalSettings.normalText_fontSize * 0.7}px`,
            justifyContent: 'center',
          }}
        />
      </div>
    )
  }
}

export default inject('editor', 'app', 'serverRender')(observer(SubmitButton))
